import Api from "@/services/Api";

export default {
  sendPasswordCode(credentials) {
    return Api().post("sendPasswordCode", credentials);
  },
  updatePassword(credentials) {
    return Api().post("updatePassword", credentials);
  },
  changePassword(credentials) {
    return Api().post("changePassword", credentials);
  },
  getStickers() {
    return Api().get("getStickers");
  },
  getSticker(slug) {
    return Api().post("getSticker", slug);
  },
  charge(chargeDetails) {
    return Api().post("charge", chargeDetails);
  },
  order(orderDetails) {
    return Api().post("order", orderDetails);
  },
  updateAddressBook(addressBook) {
    return Api().put("updateAddressBook", addressBook);
  },
  emailConfirmation(orderDetails) {
    return Api().post("emailConfirmation", orderDetails);
  },
  orders() {
    return Api().get("orders");
  },
  email(details) {
    return Api().post("email", details);
  }
};
